/** Map SKU market / country to source language for translation into English. */
export function normalizeCountryCode(country) {
  if (country == null || country === '') return '';
  const s = String(country).trim().toLowerCase();
  const aliases = {
    ro: 'RO',
    romania: 'RO',
    it: 'IT',
    italy: 'IT',
    italia: 'IT',
    uk: 'UK',
    gb: 'UK',
    'united kingdom': 'UK',
    'great britain': 'UK',
    cz: 'CZ',
    czech: 'CZ',
    czechia: 'CZ',
    'czech republic': 'CZ',
    pl: 'PL',
    poland: 'PL',
    polska: 'PL',
    se: 'SE',
    sweden: 'SE',
    sverige: 'SE',
    fr: 'FR',
    france: 'FR',
    de: 'DE',
    germany: 'DE',
    deutschland: 'DE',
    es: 'ES',
    spain: 'ES',
    españa: 'ES',
    pt: 'PT',
    portugal: 'PT',
  };
  if (aliases[s]) return aliases[s];
  if (s.length === 2) return s.toUpperCase();
  return s;
}

const COUNTRY_TO_SOURCE_LANG = {
  RO: 'ro',
  IT: 'it',
  UK: 'en',
  CZ: 'cs',
  PL: 'pl',
  SE: 'sv',
  FR: 'fr',
  DE: 'de',
  ES: 'es',
  PT: 'pt',
};

export function countryToSourceLanguage(country) {
  const code = normalizeCountryCode(country);
  return COUNTRY_TO_SOURCE_LANG[code] || 'auto';
}

export function isEnglishMarketCountry(country) {
  return countryToSourceLanguage(country) === 'en';
}

export function skuTranslationKey(title, country) {
  return `${title}\0${normalizeCountryCode(country) || '?'}`;
}

/** First market when a SKU appears in multiple countries (sorted list from overview). */
export function primaryCountryFromCountriesField(countriesField) {
  if (!countriesField) return '';
  return String(countriesField).split(',')[0]?.trim() || '';
}
